module.exports = __webpack_public_path__ + "img/activePage2.c7055783.png";